// 二级品牌馆配置 长沙学院
export default {
  'zgny.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST788802170200001651991383',
      storeName: '中国农影',
      microHost: 'zgny-brand.ubanquan.cn'
    },
    test: {
      storeNo: 'ST788802170200001651991383',
      storeName: '中国农影',
      microHost: 'zgny-brand.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST788802170200001651991383',
      storeName: '中国农影',
      microHost: 'zgny-brand.ubanquan.cn'
    },
    production: {
      storeNo: 'ST788802170200001651991383',
      storeName: '中国农影',
      microHost: 'zgny-brand.ubanquan.cn'
    }
  }
};